// extracted by mini-css-extract-plugin
export default {"statCard":"index_statCard__ODreB","label":"index_label__BWY+d","value":"index_value__VBSnw"};